
import { ProgressSpinner } from 'primereact/progressspinner';
        

const Loading = (props) => {
    return (
      <div style={{textAlign:"center",width:"100%",height:"100vh",alignContent:"center",marginTop:"3%"}}>
        <ProgressSpinner strokeWidth='3'/>
      </div>
    );
  };
  export default Loading;